module.exports = "<div class=\"pull-right\">\r\n\r\n</div>\r\n<div class=\"clearfix\"></div>"


//////////////////
// WEBPACK FOOTER
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/footer/footer.component.html
// module id = ../../../../../src/app/components/footer/footer.component.html
// module chunks = 0